/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState, useRef } from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import { connect,useDispatch } from 'react-redux';
import { withRouter } from 'react-router';
import classes from './CalculatedSensor.module.css';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FormulaBuilder from './FormulaBuilder';
import queryString from 'query-string';
import BobConfirmButton from '../../../components/BobConfirmButton';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import * as BobActions from '../../../actions/bobActions';
import * as DashboardActions from '../../../actions/dashboardActions';
import AutoComplete from '../../../components/FormFields/Autocomplete';
import * as ArchitectActions from '../../../actions/architectActions';
import * as ApplicationMessageActions from '../../../actions/applicationMessageActions';
import * as BasAgentActions from '../../../actions/basAgentActions';
import * as DeviceActions from '../../../actions/deviceActions';
import * as UiActions from '../../../actions/uiActions';
import * as SensorTypeActions from '../../../actions/sensorTypeActions';
import * as K2ACoreActions from '../../../actions/k2aCoreActions';
import { enqueueSnackbar } from '../../../actions/applicationMessageActions';
import NoSelectedSensorsScreen from '../../../components/NoSelectedSensorsScreen';
import BobModal from '../../../components/BobModal';
import BobTableContextMenu from '../../../components/BobTableContextMenu';
import * as math from 'mathjs';
import SearchInput from '../../Global/SearchInput';
import { debounce, isEmpty } from 'lodash';

const TemplateForm = ({
    activeNavClient,
    activeNavEquipment,
    activeNavSite,
    activeNavCompany,
    sensorTypes,
    agents,
    fetchSensorCalculations,
    fetchFormulaDetails,
    fetchFormulaList,
    fetchEntitySensorData,
    entitySensorData,
    fetchCompanyFormulaList,
    createTemplate,
    updateTemplate,
    setNewFormula,
    createSensorEvent,
    formulaList,
    deleteTemplate,
    sensorCalculations,
    fetchEntitySensors,
    fetchSensorsByParentId,
    fetchTemplateDetails,
    sensors,
    fetchSensorTypes,
    setNewTemplates,
    activeTemplate,
    units,
    bobLoading,
    history,
    currentUser,
    ...props
}) => {
    const dispatch = useDispatch();
    const [displayUnitTypeDisabled, setDisplayUnitTypeDisabled] = useState(false);
    const [unitTypeDisabled, setUnitTypeDisabled] = useState(false);
    const [displayUnits, setDisplayUnits] = useState();
    const [displayDataTypes, setDisplayDataTypes] = useState(['Boolean', 'Integer', 'Float', 'Text']);
    const [activeDisplayUnit, setActiveDisplayUnit] = useState({});
    const [currentTemplate, setCurrentTemplate] = useState(false);
    const text = useRef(' ');
    const extEq = useRef(null);
    const [confirmationOpen, setConfirmationOpen] = useState(false);
    const [filteredFormulas, setFilteredFormulas ] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchTerm1, setSearchTerm1] = useState('');
    const [searchTerm2, setSearchTerm2] = useState('');
    const [mode, setMode] = useState('k2a');
    const [tempFormula, setTempFormula] = useState({});
    const [editorVisible, setEditorVisible] = useState(false);
    const [filteredSensorTypes, setFilteredSensorTypes] = useState([]);
    const [calculatedVal, setCalculatedVal] = useState(false);
    let externalSensorList = [];

    const ValidationSchema = Yup.object().shape({
        name: Yup.string()
            .required(),
        dataType: Yup.string()
            .required(),
        sensorType: Yup.string()
            .required(),
        displayDataType: Yup.string()
            .required()
    });

    const handleConfirmation = () => {
        setConfirmationOpen(false);
    };

    const submitFormula = () => {
        handleConfirmation();
        loadTemplate(tempFormula);
    };

    const openConfirmation = (formula) => {
        let text = isFormulaChanged();
        if (text) {
            setTempFormula(formula);
            setConfirmationOpen(true);
        } else {
            loadTemplate(formula);
        }
    };

    useEffect(() => {
        if (formulaList && formulaList.length > 0) {
            setFilteredFormulas([...formulaList]);
        }
    }, [formulaList]);

    const getSensorTypeName = sensorTypeId => {
        return sensorTypes[0].items.find(type => type.id === sensorTypeId).name;
    };

    const filterSensorTypes = sensorTypeIds => {
        let filteredSensor = sensorTypes[0].items.filter(c => sensorTypeIds.has(c.id));
        setFilteredSensorTypes([{items: Array.from(filteredSensor)}]);
    };

    const setExternalEquipment = eq => {
        extEq.current = eq;
    };

    const filterSensorTypesRaw = sensorTypeIds => {
        let filteredSensor = sensorTypes.filter(c => sensorTypeIds.has(c.id));
        setFilteredSensorTypes([{items: Array.from(filteredSensor)}]);
    };

    useEffect(() => {
        if ( activeNavEquipment && activeNavEquipment.id && sensorTypes && sensorTypes.length > 0) {
            let sensorTypeIds = new Set();
            if ( activeNavEquipment.extendedData && activeNavEquipment.extendedData.sensors) {
                for (let sensor of activeNavEquipment.extendedData.sensors) {
                    sensorTypeIds.add(sensor.sensorTypeId);
                }
            }
            filterSensorTypes(sensorTypeIds);
        }
    }, [sensorTypes]);

    const getUnit = unitId => {
        let targetUnit;

        units.forEach(unit => {
            unit.items.forEach(item => {
                if (item.id === unitId) {
                    targetUnit = { ...item };
                }
            });
        });

        return targetUnit;
    };

    const getDisplayUnitName = displayUnitId => {
        let targetUnit;

        units.forEach(unitGroup => {
            unitGroup.items.forEach(item => {
                if (item.id === displayUnitId) {
                    targetUnit = { ...item };
                }
            });
        });

        if (targetUnit) {
            return targetUnit.name;
        }

        return '';
    };

    const handleSearch = async searchTerm => {
        setSearchTerm(searchTerm);

        if (isEmpty(searchTerm)) {
            setFilteredFormulas([...formulaList]);
        } else {
            const filteredSensors = formulaList.filter(sensor => sensor.name.toLowerCase().includes(searchTerm.toLowerCase()));
            setFilteredFormulas([...filteredSensors]);
        }
    };

    const handleSearch2 = async searchTerm => {
        setSearchTerm2(searchTerm);
    };

    const handleSearch1 = async searchTerm => {
        setSearchTerm1(searchTerm);
    };

    const loadFormula = (formula) => {
        setCalculatedVal('');
        setEditorVisible(true);
        const options = {
            formulaId:     formula.id,
            companyId:     '00000000-0000-0000-0000-000000000000',
            effectiveDate: formula.effectiveTimestamp
        };
        let promises = [fetchFormulaDetails(options)];
        Promise.all(promises.map(p => p.catch(err => err)));
    };

    const loadCloneTemplate = (formula) => {
        setCurrentTemplate(formula);
    };

    const loadTemplate = (formula) => {
        setCalculatedVal('');
        setEditorVisible(true);
        const options = {
            id: formula.id
        };
        let promises = [fetchTemplateDetails(options)];
        Promise.all(promises.map(p => p.catch(err => err)));
    };

    const cloneTemplate = (type) => {
        setCalculatedVal('');
        if (type === 'clone') {
            setEditorVisible(true);
            const options = {
                id:   currentTemplate.id,
                mode: 'clone'
            };
            let promises = [fetchTemplateDetails(options)];
            Promise.all(promises.map(p => p.catch(err => err)));
        }
        else if (type === 'delete') {
            deActivateTemplate();
        }
    };

    const deActivateTemplate = () => {
        const save = async () => {
            if (currentTemplate && currentTemplate.id) {
                const options = {
                    id: currentTemplate.id
                };
                await deleteTemplate(options);
                if (queryValues.system) {
                    await fetchSensorCalculations({ systemId: queryValues.system });
                } else {
                    await fetchSensorCalculations({ equipmentId: queryValues.equipment });
                }
            }
        };
        save();
    };

    let formVal = {
        initialValues: {
            name:            '',
            sensorType:      '',
            dataType:        '',
            displayDataType: '',
            unit:            '',
            displayUnit:     ''

        },
        validationSchema:   ValidationSchema,
        enableReinitialize: true,
        onSubmit:           async (values, { setSubmitting }) => {
        }
    };

    const formik = useFormik(formVal);

    const handleBackClick = () => {
        if (mode === 'company') {
            newComapnyTemplate();
        }
        else newTemplate();
    };

    const handleSensorTypeChange = event => {
        const { value } = event.target;

        if (formik.values.name) {
            formik.handleChange(event);

            return;
        }
        formik.handleChange(event);
    };

    const newTemplate = event => {
        setCalculatedVal('');
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        setMode('k2a');
        setNewFormula();
        setNewTemplates();
        setEditorVisible(true);
        formik.setFieldValue('name', '', false);
        formik.setFieldValue('sensorType', '', false);
        formik.setFieldValue('unit', '', false);
        formik.setFieldValue('dataType', '', false);
        formik.setFieldValue('displayDataType', '', false);
        formik.setFieldValue('displayUnit', '', false);
    };

    const newComapnyTemplate = event => {
        setCalculatedVal('');
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        setMode('company');
        setNewFormula();
        setNewTemplates();
        setEditorVisible(true);
        formik.setFieldValue('name', '', false);
        formik.setFieldValue('sensorType', '', false);
        formik.setFieldValue('unit', '', false);
        formik.setFieldValue('dataType', '', false);
        formik.setFieldValue('displayDataType', '', false);
        formik.setFieldValue('displayUnit', '', false);
    };

    const handleCancel = event => {
        setCalculatedVal('');
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        setMode('k2a');
        setNewFormula();
        setNewTemplates();
        setEditorVisible(false);
        formik.setFieldValue('name', '', false);
        formik.setFieldValue('sensorType', '', false);
        formik.setFieldValue('unit', '', false);
        formik.setFieldValue('dataType', '', false);
        formik.setFieldValue('displayDataType', '', false);
        formik.setFieldValue('displayUnit', '', false);
    };

    const handleUnitChange = event => {
        formik.handleChange(event);
        let displayUnits;

        formik.setFieldValue('displayUnit', event.target.value);
    };

    const handleDisplayUnitChange = event => {
        formik.handleChange(event);
        setActiveDisplayUnit(event.target.value);
    };

    const syncTitle = (val, mode) => {
        if (mode === 'formula') {
            if (formik.values.name === '') {
                text.current = val;
                formik.setFieldValue('name', val, false);
            }
        }
        else {
            text.current = val;
            formik.setFieldValue('name', val, false);
        }
    };

    const handleTestConfirmation = () => {
    };

    const queryValues = queryString.parse(history.location.search);

    useEffect(() => {
        const init = async () => {
            let promises = [];

            if (queryValues.system) {
                promises.push(fetchSensorCalculations({ systemId: queryValues.system }));
            } else {
                promises.push(fetchSensorCalculations({ equipmentId: queryValues.equipment }));
            }
            promises.push(fetchSensorTypes());
            Promise.all(promises.map(p => p.catch(err => err)));
        };

        if (activeNavCompany.id) init();
    }, [activeNavCompany]);

    const getStringFromHTMLFormula = () => {
        let text = '';
        let sensors = [];
        let input = document.querySelector('#formula-editor');
        if (input && input.childNodes) {
            for (let i = 0; i < input.childNodes.length; i++) {
                if (input.childNodes[i].getAttribute && input.childNodes[i].getAttribute('data-ui-variable')) {
                    text += 'sensors["' + input.childNodes[i].getAttribute('data-ui-variable') + '"]';
                    const isExternal = input.childNodes[i].getAttribute('data-external') === 'true' ? true : false;
                    sensors.push({
                        id:               input.childNodes[i].getAttribute('data-ui-variable'),
                        name:             input.childNodes[i].textContent.replaceAll('*', ''),
                        isExternalSensor: isExternal,
                        siteId:           isExternal ? input.childNodes[i].getAttribute('data-siteId') : null,
                        equipmentId:      isExternal ? input.childNodes[i].getAttribute('data-equipmentId') : null
                    });
                }
                else if (input.childNodes[i].tagName && input.childNodes[i].tagName.toLowerCase() === 'input') {
                    text += '{' + input.childNodes[i].value + '}';
                }
                else text += input.childNodes[i].textContent;
            }
            text = text.replace(/(\r\n|\n|\r)/gm, '').trim();
            return { text: 'return ' + text, sensors: sensors };
        }
    };

    const getSensorIds = () => {
        externalSensorList = [];
        let text = '';
        let sensors = new Map();
        let input = document.querySelector('#formula-editor');
        if (input && input.childNodes) {
            for (let i = 0; i < input.childNodes.length; i++) {
                if (input.childNodes[i].getAttribute && input.childNodes[i].getAttribute('data-ui-variable')) {
                    sensors.set(input.childNodes[i].getAttribute('data-ui-variable'), i + 1);
                    const isExternal = input.childNodes[i].getAttribute('data-external');
                    if (isExternal && isExternal === 'true') {
                        const siteId = input.childNodes[i].getAttribute('data-siteId');
                        const equipmentId = input.childNodes[i].getAttribute('data-equipmentId');
                        const sensorId = input.childNodes[i].getAttribute('data-ui-variable');
                        const externalSensor = {siteId: siteId, equipmentId: equipmentId, sensorId: sensorId};
                        if (externalSensorList.findIndex(s => s.sensorId === externalSensor.sensorId) === -1) {
                            externalSensorList.push(externalSensor);
                        }
                    }
                }
            }
        }
        return sensors;
    };

    useEffect(() => {
        if (entitySensorData && entitySensorData.length > 0) {
            let _sensors = getSensorIds();
            for ( let sid of _sensors) {
                if ( activeNavEquipment.extendedData && activeNavEquipment.extendedData.sensors && activeNavEquipment.extendedData.sensors.length > 0 ) {
                    let ts = activeNavEquipment.extendedData.sensors.filter(c => c.sensorTypeId === sid[0]);
                    if (ts && ts.length >0) {
                        let sensorId = ts[0].id;
                        for ( let ds of entitySensorData) {
                            if (sensorId === ds.sensorId) {
                                if (ds && ds.data && ds.data.length>0) {
                                    let cval =  ds.data.filter(c => c.convertedValue != null);
                                    if (cval && cval.length > 0) {
                                        _sensors.set(sid[0], cval[0].convertedValue);
                                    }
                                }
                            }
                        }
                    }
                }
            }

            try {
                let formula = '';
                let input = document.querySelector('#formula-editor');
                if (input && input.childNodes) {
                    for (let i = 0; i < input.childNodes.length; i++) {
                        if (input.childNodes[i].getAttribute && input.childNodes[i].getAttribute('data-ui-variable')) {
                            if (input.childNodes[i].classList.contains('variable-token')) {
                                formula += _sensors.get(input.childNodes[i].getAttribute('data-ui-variable'));
                            }
                            else throw new Error('Expression is not valid.');
                        }
                        else if (input.childNodes[i].tagName && input.childNodes[i].tagName.toLowerCase() === 'input') {
                            formula += input.childNodes[i].value;
                        }
                        else formula += input.childNodes[i].textContent;
                    }
                    formula = formula.replace(/(\r\n|\n|\r)/gm, '').trim();
                    formula = formula.replace(/\u00A0/g, '');
                    let tempFormula =  formula.replaceAll('avg', 'mean');
                    tempFormula = tempFormula.replaceAll('Math.', '');
                    tempFormula = tempFormula.replaceAll('{', '').replaceAll('}', '');
                    try {
                        let hasNull = false;
                        let hasPollFailure = false;

                        if (tempFormula.includes(null) || tempFormula.includes('null')) hasNull = true;
                        if (tempFormula.includes('Poll Failure')) hasPollFailure = true;

                        let calculatedformula = tempFormula.replace(null, '0');
                        calculatedformula = calculatedformula.replace('null', '0');
                        calculatedformula = calculatedformula.replace('Poll Failure', '0');

                        calculatedformula = calculatedformula.replace('runtime_calculation', '');
                        let result = math.evaluate(calculatedformula);
                        setCalculatedVal(formula + ' = ' + result);
                        dispatch(enqueueSnackbar('Calculation tested successfully.', 'success'));
                    } catch (e) {
                        setCalculatedVal('Expression is not valid.');
                        dispatch(enqueueSnackbar('Expression is not valid.', 'error'));
                    }
                }
            }
            catch (e) {
                dispatch(enqueueSnackbar('Expression is not valid.', 'error'));
            }
        }

    }, [entitySensorData]);

    const  validateTemplate = async () => {
        const init = async (sensors) => {
            let promises = [];
            let sensorTypeIds = Array.from(sensors.keys());
            let _sensors = [];
            for ( let sid of sensorTypeIds) {
                if ( activeNavEquipment.extendedData && activeNavEquipment.extendedData.sensors) {
                    let ts = activeNavEquipment.extendedData.sensors.filter(c => c.sensorTypeId === sid);
                    if (ts && ts.length > 0) {
                        _sensors.push(ts[0].id);
                    }
                    else {
                        if ( extEq && extEq.current && extEq.current.extendedData && extEq.current.extendedData.sensors) {
                            let ts1 = extEq.current.extendedData.sensors.filter(c => c.sensorTypeId === sid);
                            if (ts1 && ts1.length > 0) {
                                _sensors.push(ts1[0].id);
                            }
                        }
                        else {
                            const externals = externalSensorList.filter(c => c.sensorId === sid);
                            // needt to find a sensor of the type for this piece of equipment
                            if (externals) {
                                const equipmentSensors = await fetchSensorsByParentId(externals[0].siteId, externals[0].equipmentId, {limit: 500, page: 1});
                                if (!isEmpty(equipmentSensors)) {
                                    const sensor = equipmentSensors.find(s => s.sensorTypeId === externals[0].id);
                                    if (sensor) {
                                        _sensors.push(sensor.id);
                                    }
                                }
                            }
                        }
                    }
                }
            }
            promises.push(fetchEntitySensorData(_sensors.map(c =>
            { return {'id': c};
            }), null, null, 60));
            await Promise.all(promises.map(p => p.catch(err => err)));
        };
        let sensors = getSensorIds();
        init(sensors);
    };

    useEffect(() => {
        setEditorVisible(false);
    }, [createSensorEvent]);

    useEffect(() => {
        if (activeTemplate && sensorTypes && sensorTypes.length > 0) {
            //Edit
            if (activeTemplate.id) {
                formik.setFieldValue('name',activeTemplate.mode === 'clone' ? '' : activeTemplate.name, false);
                formik.setFieldTouched('name', false);
                let sensorType = sensorTypes[0].items.find(c => c.id === activeTemplate.sensorTypeId);
                if (sensorType) {
                    formik.setFieldValue('sensorType', sensorType, false);
                    formik.setFieldTouched('sensorType', false);
                }
                let unit = units.find(c => {
                    return c.items.some(d => d.id === activeTemplate.rawUnitId);
                });

                formik.setFieldValue('unit', getUnit(activeTemplate.rawUnitId), false);
                formik.setFieldTouched('unit', false);
                formik.setFieldValue('displayUnit', getUnit(activeTemplate.rawUnitId), false);
                formik.setFieldValue('displayDataType', activeTemplate.outputDataType.charAt(0).toUpperCase() + activeTemplate.outputDataType.slice(1), true);
                formik.setFieldTouched('displayDataType', false);
                formik.validateForm();
            }
        }
    }, [activeTemplate]);

    const isFormulaChanged = () => {
        let ip = document.querySelector('#formula-editor');
        if (ip === null) {
            return false;
        }
        let str = getStringFromHTMLFormula();
        const template = str?.text;
        if (template && activeTemplate && activeTemplate.id) {
            return template.replace(/\s/g, '') !== activeTemplate.formulaCode.replace(/\s/g, '') ? true : false;
        }
        else if (template) {
            return true;
        }
        return false;
    };

    const fetchUserData = ( actionType ) => {
        switch (actionType) {
            case 'clone':
                loadTemplate(actionType);
                break;
            case 'enable':
                cloneFormula(actionType);
                break;
            case 'disable':
                cloneFormula(actionType);
                break;
            default:
                break;
        }
    };

    const cloneFormula = (actionType) =>{
        const template = getStringFromHTMLFormula();
        const save = async () => {
            let body = {
                'sensorTypeId':    formik.values.sensorType.id,
                'rawUnitId':       activeTemplate && activeTemplate.id && formik.values.unit.items && formik.values.unit.items.length > 0 ? formik.values.unit.items[0].id : formik.values.unit.id,
                'name':            text.current + '_cloned',
                'outputDataType':  formik.values.displayDataType.toLowerCase(),
                'sensors':         template.sensors,
                'formulaCode':     template.text,
                'formulaXml':      '',
                'isK2ATemplate':   false,
                'equipmentTypeId': activeNavEquipment.equipmentType ? activeNavEquipment.equipmentType.id : ''
            };

            if (text.current && template.text) {
                await createTemplate(body);
                if (queryValues.system) {
                    await fetchSensorCalculations({ systemId: queryValues.system });
                } else {
                    await fetchSensorCalculations({ equipmentId: queryValues.equipment });
                }
            }
            else {
                dispatch(enqueueSnackbar('Please fill the mandatory fields.', 'error'));
            }

        };

        save();
    };


    const handleApply = () => {
        if (!(formik.values.sensorType && formik.values.unit && formik.values.name && text &&  text.current)) {
            dispatch(enqueueSnackbar('Please fill the mandatory fields.', 'error'));
            return;
        }
        const template = getStringFromHTMLFormula();
        const save = async () => {
            let body = {
                'sensorTypeId':    formik.values.sensorType.id,
                'rawUnitId':       formik.values && formik.values.unit.id,
                'name':            text.current,
                'outputDataType':  formik.values.displayDataType.toLowerCase(),
                'sensors':         template.sensors,
                'formulaCode':     template.text,
                'formulaXml':      '',
                'isK2ATemplate':   mode === 'k2a' ? true : false,
                'equipmentTypeId': activeNavEquipment.equipmentType ? activeNavEquipment.equipmentType.id :''
            };

            if (activeTemplate.mode === 'clone') {
                body.isK2ATemplate = false;
            }
            if (activeTemplate && activeTemplate.id && activeTemplate.companyId !== '00000000-0000-0000-0000-000000000000') {
                body.isK2ATemplate = false;
            }
            if (text.current && template.text && body.rawUnitId && body.sensorTypeId) {
                if (activeTemplate && activeTemplate.id && activeTemplate.mode !== 'clone') {
                    const options = {
                        id: activeTemplate.id
                    };
                    await updateTemplate(options,body);
                }
                else

                    await createTemplate(body);
                if (queryValues.system) {
                    await fetchSensorCalculations({ systemId: queryValues.system });
                } else {
                    await fetchSensorCalculations({ equipmentId: queryValues.equipment });
                }
            }
            else {
                dispatch(enqueueSnackbar('Please fill the mandatory fields.', 'error'));
            }
        };
        save();
    };

    useEffect(() => {
        const init = async () => {
            let company = '00000000-0000-0000-0000-000000000000';
            let promises = [fetchFormulaList(company, {})];
            Promise.all(promises.map(p => p.catch(err => err)));
        };

        if (activeNavCompany.id) init();
    }, [activeNavCompany]);

    return (
        <React.Fragment>
            <div className={`calculated-sensor calculated-sensor-template ${classes.CalculationContainer}`}>
                <div className={classes.FormulaForm}>
                    <div className={classes.TemplateCol}>
                        <Accordion defaultExpanded={true} className={classes.accordion}>
                            <AccordionSummary
                                className={classes.accordionSummary}
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <div>
                                    Formulas
                                    <div className={`${classes.SearchContainer} ${'search-accordion'}`} style={{marginBottom: 10}}>
                                        <SearchInput
                                            key={new Date()}
                                            className={classes.SearchInput}
                                            search={debounce(handleSearch, 400)}
                                            stopPropagation={true}
                                            placeholder={`Search`}
                                            value={searchTerm}
                                        />
                                    </div>
                                </div>
                            </AccordionSummary>
                            {formulaList && formulaList.length > 0 ?
                                <AccordionDetails className={classes.AccordionContentTemplate}>
                                    {filteredFormulas.map((c, i) =>
                                        <span
                                            key={i}
                                            role="button"
                                            tabIndex={0}
                                            onClick={() => loadFormula(c)}
                                            style={{ curspor: 'pointer' }}
                                        >
                                            {c.name}
                                        </span>)}
                                </AccordionDetails>
                                :
                                ''
                            }
                        </Accordion>
                        <Accordion defaultExpanded={true} className={classes.accordion}>
                            <AccordionSummary
                                className={classes.accordionSummary}
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <div style={{width: '100%'}}>
                                    K2A Templates
                                    {currentUser && currentUser.isSuperUser ?
                                        <span
                                            onClick={newTemplate}
                                            style={{float: 'right', color: '#666666'}}
                                            title=" Create New K2A Template"
                                            className="material-icons-outlined"
                                        >add</span>:''}
                                    <div className={`${classes.SearchContainer} ${'search-accordion'}`} style={{marginBottom: 10}}>
                                        <SearchInput
                                            key={new Date()}
                                            className={classes.SearchInput}
                                            search={debounce(handleSearch1, 400)}
                                            stopPropagation={true}
                                            placeholder={`Search`}
                                            value={searchTerm1}
                                        />
                                    </div>
                                </div>
                            </AccordionSummary>
                            <AccordionDetails className={classes.AccordionContentTemplate}>
                                {sensorCalculations && sensorCalculations.length > 0 ? sensorCalculations.filter(c => c.companyId === '00000000-0000-0000-0000-000000000000')
                                    .filter(searchTerm1 ? sensor => sensor.name.toLowerCase().includes(searchTerm1.toLowerCase()) : Boolean)
                                    .map((c, i) =>
                                        <span key={i} className={'calc-menu-span'}>
                                            <span
                                                role="button"
                                                tabIndex={0}
                                                onClick={() => openConfirmation(c)}
                                                className={'calc-menu-span-label'}
                                                style={{ curspor: 'pointer' }}
                                            >
                                                {c.name}
                                            </span>
                                            {currentUser && currentUser.isSuperUser ?
                                                <BobTableContextMenu
                                                    type="K2ATemplate"
                                                    entityData={props.dataItem}
                                                    loadFormula = {loadCloneTemplate.bind(c)}
                                                    formula={c}
                                                    onFetch={(type) => cloneTemplate(type) }
                                                />
                                                :
                                                ''
                                            }
                                        </span>
                                    )
                                    :
                                    ''
                                }
                            </AccordionDetails>
                        </Accordion>
                        <Accordion defaultExpanded={true} className={classes.accordion}>
                            <AccordionSummary
                                className={classes.accordionSummary}
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <div style={{width: '100%'}}>
                                    Company Templates
                                    <span
                                        onClick={newComapnyTemplate}
                                        style={{float: 'right',color: '#666666'}}
                                        title=" Create New Company Template"
                                        className="material-icons-outlined"
                                    >
                                        add
                                    </span>
                                    <div className={`${classes.SearchContainer} ${'search-accordion'}`} style={{marginBottom: 10}}>
                                        <SearchInput
                                            key={new Date()}
                                            className={classes.SearchInput}
                                            stopPropagation={true}
                                            search={debounce(handleSearch2, 400)}
                                            placeholder={`Search`}
                                            value={searchTerm2}
                                        />
                                    </div>
                                </div>
                            </AccordionSummary>
                            <AccordionDetails className={classes.AccordionContentTemplate}>
                                {sensorCalculations && sensorCalculations.length > 0 ? sensorCalculations.filter(c => c.companyId !== '00000000-0000-0000-0000-000000000000')
                                    .filter(searchTerm2 ? sensor => sensor.name.toLowerCase().includes(searchTerm2.toLowerCase()) : Boolean)
                                    .map((c, i) =>
                                        <span key={i} className={'calc-menu-span'}>
                                            <span
                                                role="button" tabIndex={0}
                                                onClick={() => openConfirmation(c)}
                                                className={'calc-menu-span-label'}
                                                style={{ curspor: 'pointer' }}
                                            >
                                                {c.name}
                                            </span>
                                            <BobTableContextMenu
                                                type="Template"
                                                entityData={props.dataItem}
                                                loadFormula = {loadCloneTemplate.bind(c)}
                                                formula={c}
                                                onFetch={(type) => cloneTemplate(type) }
                                            />
                                        </span>
                                    )
                                    :
                                    ''
                                }
                            </AccordionDetails>
                        </Accordion>
                    </div>
                    <div className={classes.TemplateFormulabuilder} >
                        {editorVisible ?
                            <div>
                                <FormulaBuilder
                                    mode={'template'}
                                    syncTitle={syncTitle}
                                    filterSensorTypes={filterSensorTypes}
                                    filterSensorTypesRaw={filterSensorTypesRaw}
                                    setExternalEquipment={setExternalEquipment}
                                />
                                <span className={classes.validationDescription}>{'The tested calculation uses sample data from the first sensors found for the sensor types. It may not reflect actual results.'}</span>
                                <span className={classes.calculateLbl}>{`Tested value: ${calculatedVal?calculatedVal:'--'}`}</span>
                            </div>
                            :
                            <NoSelectedSensorsScreen
                                style={{
                                    width:      '80%',
                                    margin:     '0',
                                    marginLeft: '1rem',
                                    borderLeft: '1px solid #eeeff0'
                                }}
                                message="Please select an existing template or create a new template to continue."
                                height={'calc(100vh - 275px)'}
                            />
                        }
                        {editorVisible ?
                            <div className={classes.inputs} >
                                <div className={classes.formRow}>
                                    <FormControl className={classes.userInputWrapper} style={{ width: 415, marginLeft: 15 }}>
                                        <TextField
                                            id="name"
                                            name="name"
                                            type="text"
                                            disabled={true}
                                            value={formik.values.name}
                                            label={<span>Template Name<span className={classes.required}> *</span></span>}
                                            onChange={formik.handleChange}
                                            InputLabelProps={{
                                                classes: {
                                                    error:   classes.error,
                                                    focused: classes.labelFocused,
                                                    root:    classes.label
                                                }
                                            }}
                                            inputProps={{ maxLength: 250 }}
                                            InputProps={{
                                                onBlur:  formik.handleBlur,
                                                classes: {
                                                    error:     classes.cssErrorUnderline,
                                                    underline: classes.cssUnderline,
                                                    root:      classes.input
                                                }
                                            }}
                                            FormHelperTextProps={{
                                                classes: {
                                                    error: classes.error
                                                }
                                            }}
                                            error={Boolean(formik.errors.name) && Boolean(formik.touched.name)}
                                            helperText={Boolean(formik.touched.name) && formik.errors.name}
                                        />
                                    </FormControl>
                                    <FormControl className={classes.userInputWrapper} style={{ width: 415, marginLeft: 25 }}>
                                        <AutoComplete
                                            grouped
                                            label={<span>Sensor Type<span className={classes.required}> *</span></span>}
                                            name="sensorType"
                                            onBlur={formik.handleBlur}
                                            onChange={handleSensorTypeChange}
                                            options={sensorTypes}
                                            placeholder="Sensor Type"
                                            value={formik.values.sensorType}
                                            error={Boolean(formik.errors.sensorType) && Boolean(formik.touched.sensorType)}
                                            helperText={Boolean(formik.touched.sensorType) && formik.errors.sensorType}
                                        />
                                    </FormControl>
                                </div>
                                <div className={classes.formRow} style={{ marginBottom: 15 }}>
                                    <FormControl className={classes.inputWrapper} style={{ width: 200, marginLeft: 15 }}>
                                        <InputLabel
                                            htmlFor="deviceObject"
                                            classes={{
                                                error:   classes.Error,
                                                focused: classes.LabelFocused,
                                                root:    classes.Label
                                            }}
                                            error={Boolean(formik.errors.deviceObject) && Boolean(formik.touched.deviceObject)}
                                        >
                                            Data Type<span className={classes.Required}> *</span>
                                        </InputLabel>
                                        <Select
                                            value={formik.values.displayDataType}
                                            onChange={formik.handleChange}
                                            className={classes.Select}
                                            inputProps={{
                                                name:   'displayDataType',
                                                id:     'displayDataType',
                                                onBlur: formik.handleBlur
                                            }}
                                            error={Boolean(formik.errors.displayDataType) && Boolean(formik.touched.displayDataType)}
                                        >
                                            {
                                                displayDataTypes.map(objectItem =>
                                                    <MenuItem
                                                        key={objectItem}
                                                        value={objectItem}
                                                    >
                                                        {objectItem}
                                                    </MenuItem>
                                                )
                                            }
                                        </Select>
                                    </FormControl>
                                    <FormControl className={classes.inputWrapper} style={{ width: 200, marginLeft: 15 }}>
                                        <InputLabel
                                            htmlFor="deviceObject"
                                            classes={{
                                                error:   classes.Error,
                                                focused: classes.LabelFocused,
                                                root:    classes.Label
                                            }}
                                            error={Boolean(formik.errors.deviceObject) && Boolean(formik.touched.deviceObject)}
                                        >
                                            Display Data Type<span className={classes.Required}> *</span>
                                        </InputLabel>
                                        <Select
                                            value={formik.values.displayDataType}
                                            onChange={formik.handleChange}
                                            className={classes.Select}
                                            inputProps={{
                                                name:   'displayDataType',
                                                id:     'displayDataType',
                                                onBlur: formik.handleBlur
                                            }}
                                            error={Boolean(formik.errors.displayDataType) && Boolean(formik.touched.displayDataType)}
                                        >
                                            {
                                                displayDataTypes.map(objectItem =>
                                                    <MenuItem
                                                        key={objectItem}
                                                        value={objectItem}
                                                    >
                                                        {objectItem}
                                                    </MenuItem>
                                                )
                                            }
                                        </Select>
                                    </FormControl>
                                    <FormControl className={classes.inputWrapper} style={{ width: 200, marginLeft: 25 }}>
                                        <AutoComplete
                                            grouped
                                            disabled={unitTypeDisabled}
                                            label={<span>Raw Unit<span className={classes.required}> *</span></span>}
                                            name="unit"
                                            onBlur={formik.handleBlur}
                                            onChange={handleUnitChange}
                                            options={units}
                                            error={Boolean(formik.errors.unit) && Boolean(formik.touched.unit)}
                                            helperText={Boolean(formik.errors.unit) && Boolean(formik.touched.unit) ? formik.errors.unit : null}
                                            placeholder="Unit"
                                            value={formik.values.unit}
                                        />
                                    </FormControl>
                                    <FormControl className={classes.inputWrapper} style={{ width: 200, marginLeft: 25 }}>
                                        <AutoComplete
                                            grouped
                                            disabled={displayUnitTypeDisabled}
                                            label={<span>Display Unit<span className={classes.required}> *</span></span>}
                                            name="displayUnit"
                                            onBlur={formik.handleBlur}
                                            onChange={handleDisplayUnitChange}
                                            options={displayUnits}
                                            error={Boolean(formik.errors.displayUnit) && Boolean(formik.touched.displayUnit)}
                                            helperText={Boolean(formik.errors.displayUnit) && Boolean(formik.touched.displayUnit) ? formik.errors.displayUnit : null}
                                            placeholder="Display Unit"
                                            value={formik.values.displayUnit}
                                        />
                                    </FormControl>
                                </div>
                            </div>
                            :
                            ''
                        }
                    </div>
                </div>
            </div>
            <div className={classes.ButtonContainer}>
                <BobConfirmButton
                    className={classes.Button}
                    style={{ marginLeft: 15, float: 'right' }}
                    variant="contained"
                    disabled={!editorVisible}
                    onClick={handleCancel}
                >
                    Cancel
                </BobConfirmButton>
                <BobConfirmButton
                    disabled={!editorVisible}
                    style={{ marginLeft: 15, float: 'right' }}
                    onClick={handleApply}
                    label={'Save Template'}
                />
                <BobConfirmButton
                    className={classes.ButtonWithMargin}
                    isLoading={false}
                    disabled={!editorVisible}
                    onClick={validateTemplate}
                    label={'Test Calculation'}
                />
            </div>
            {confirmationOpen ?
                <BobModal
                    confirmText="Yes"
                    cancelText="No"
                    rootClass={'announcement-delete-modal formula-delete-modal'}
                    onCancel={handleConfirmation}
                    onClose={handleConfirmation}
                    onConfirm={submitFormula}
                    open={confirmationOpen}
                    title={'Formula Confirmation'}
                >
                    Your unsaved changes will be discarded. Are you sure you wish to continue?
                </BobModal>
                :
                ''
            }
        </React.Fragment>
    );
};

const mapStateToProps = ({ basAgent, ...state }) => {
    const { basAgents } = basAgent;

    return {
        activeNavEquipment: state.bob.activeNavEquipment,
        activeNavClient:    state.bob.activeNavClient,
        activeNavCompany:   state.bob.activeNavCompany,
        activeNavSite:      state.bob.activeNavSite,
        agents:             Object.values(basAgents),
        bobLoading:         state.bob.bobLoading,
        sensorCalculations: state.dashboard.sensorCalculations,
        sensorTypes:        state.sensorTypes.data,
        units:              state.architect.rawUnits,
        formulaList:        state.dashboard.formulaList,
        activeTemplate:     state.dashboard.activeTemplate,
        currentUser:        state.currentUser,
        createSensorEvent:  state.dashboard.createSensorEvent,
        entitySensorData:   state.bob.entitySensorData
    };
};

const mapDispatchToProps = {
    ...BobActions,
    ...DashboardActions,
    ...ArchitectActions,
    ...ApplicationMessageActions,
    ...BasAgentActions,
    ...DeviceActions,
    ...UiActions,
    ...SensorTypeActions,
    ...K2ACoreActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TemplateForm));
